import { createActionGroup, props } from '@ngrx/store';
import { BoardMigrationStatus } from '../../model/board-migration-status';

export const migrationStatusActions = createActionGroup({
  source: 'Migration Status Effects Actions',
  events: {
    'Loaded migration status': props<{ boardId: string; migrationStatus: BoardMigrationStatus }>(),
    'Loaded migration status without params': props<{ boardId: string }>(),
    'Reload migration status': props<{ boardId: string }>(),
  },
});
